import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import AutoComplete from '../AutoComplete'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { useGetAffiliazioniLightQuery } from '../../hooks/api-slice'

const SelectSocieta = () => {
  const { data: affiliazioniLight } = useGetAffiliazioniLightQuery()
  const selectedSocieta = useSelector(state => state.selection.selectedSocieta)

  const { setSelectedSocieta } = useSelectionSet()

  const getOptionLabel = op => {
    const a = affiliazioniLight?.find(a => a?.id === (op?.id || op))
    return `${a?.codiceSocieta} - ${a?.nomeSocieta}`
  }

  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <AutoComplete
        id='available-societa'
        label='Società'
        value={selectedSocieta}
        options={affiliazioniLight}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(op, value) => op?.id === value}
        disabled={!affiliazioniLight}
        onChange={i => setSelectedSocieta(i?.id)}
      />
    </Grid>
  )
}

export default SelectSocieta
